module.exports = __webpack_public_path__ + "static/media/009.2a0c4cb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/009.jpg
// module id = 482
// module chunks = 0